import Util from './Util';
const util= new Util();
const sers='hkjs65$is*88643346%';
const str_cla_storage='mec_ch_con_s';

class StoreHandler {
    constructor() {}

    setItem(key, value) {   
        if(sessionStorage.getItem(str_cla_storage)==null){
            sessionStorage.setItem(str_cla_storage, util.encryp(JSON.stringify({}),sers));
        }

        let sj_r=JSON.parse(util.decryp(sessionStorage.getItem(str_cla_storage),sers));
        sj_r[key]=value;
        sessionStorage.setItem(str_cla_storage, util.encryp(JSON.stringify(sj_r),sers));
    }

    getItem(key) {
        if(sessionStorage.getItem(str_cla_storage)==null){
            sessionStorage.setItem(str_cla_storage, util.encryp(JSON.stringify({}),sers));
        }

        let sj_r=JSON.parse(util.decryp(sessionStorage.getItem(str_cla_storage),sers));
        return sj_r[key];
    }

    removeItem(key) {
        if(sessionStorage.getItem(str_cla_storage)==null){
            sessionStorage.setItem(str_cla_storage, util.encryp(JSON.stringify({}),sers));
        }

        let sj_r=JSON.parse(util.decryp(sessionStorage.getItem(str_cla_storage),sers));
        delete sj_r[key];
        sessionStorage.setItem(str_cla_storage, util.encryp(JSON.stringify(sj_r),sers));
    }

    clear() {
        sessionStorage.removeItem(str_cla_storage);
    }
}

export default StoreHandler;